'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './positionType.routes.js';
import PositionTypeListCtrl from './list/list.controller.js';
import PositionTypeViewCtrl from './view/view.controller.js';
import PositionTypeFormCtrl from './form/form.controller.js';

export default angular.module('georgeApp.positionType',
  [uiRouter])
  .config(routing)
  .controller('PositionTypeListCtrl', PositionTypeListCtrl)
  .controller('PositionTypeViewCtrl', PositionTypeViewCtrl)
  .controller('PositionTypeFormCtrl', PositionTypeFormCtrl)
  .name;
